// src/app/[username]/page.tsx
"use client";
import { useRouter, useParams } from "next/navigation";
import { useEffect } from "react";

// Minimal client redirect to /lit/:username
export default function Page() {
  const router = useRouter();
  const params = useParams() as { username: string };

  useEffect(() => {
    if (params?.username) {
      router.replace(`/lit/${encodeURIComponent(params.username)}`);
    }
  }, [params, router]);

  return null; // nothing to render
}
